import { ProjectModulePipelineBase } from './base/project-module-pipeline-base';

export class ProjectModulePipeline extends ProjectModulePipelineBase { }